import { AuthMethodTypeEnum } from "@/api/common-types";
import { IEnumState, IObjectTypeState } from "@/models";
import { Component, Emit, Prop, Vue } from "vue-property-decorator";

import { GraphqlApiSchemaHandler } from "@/models/api-schema/graphql-api-schema-handler";
import { BCard } from "@/lib/typed-bootstrap";
import { ApolloClient } from "apollo-boost";
import * as tsx from "vue-tsx-support";
import Tabs from "../shared/Tabs.component";
import { ObjectTypeConnections } from "./ObjectTypeConnections.component";
import { ObjectTypeTriggers } from "./ObjectTypeTriggers.component";
import style from "./ObjectTypeWidget.component.module.scss";

@Component
export default class ObjectTypeWidget extends Vue {
  _tsx!: tsx.DeclareProps<{
    apiAuthMode: ObjectTypeWidget["apiAuthMode"];
    value: ObjectTypeWidget["value"];
    allTypes: ObjectTypeWidget["allTypes"];
    currentTabIndex: ObjectTypeWidget["currentTabIndex"];
    allEnumTypes?: ObjectTypeWidget["allEnumTypes"];
    isUnique?: ObjectTypeWidget["isUnique"];
    isReserved?: ObjectTypeWidget["isReserved"];
    apiClient?: ObjectTypeWidget["apiClient"];
    apiSchemaHandler?: ObjectTypeWidget["apiSchemaHandler"];
  }> &
    tsx.DeclareOnEvents<{
      onAddEnumType: void;
      onAddObjectTypeField: void;
      onTabIndexChange: number;
    }>;

  @Prop({ required: true }) apiAuthMode: AuthMethodTypeEnum;
  @Prop({ required: true }) value: IObjectTypeState;
  @Prop({ required: true }) allTypes: IObjectTypeState[];
  @Prop({ required: true }) currentTabIndex: number;
  @Prop({ required: false, default: null }) allEnumTypes: IEnumState[] | null;
  @Prop({ required: false, default: null }) readonly isUnique: boolean | null;
  @Prop({ required: false, default: false }) readonly isReserved: boolean;
  @Prop({ required: false, default: null })
  apiClient: ApolloClient<unknown> | null;
  @Prop({ required: false, default: null })
  apiSchemaHandler: GraphqlApiSchemaHandler | null;

  @Emit("addEnumType") onAddEnumType() {}
  @Emit("addObjectTypeField") onAddObjectTypeField() {}
  @Emit("tabIndexChange") onTabIndexChange(_index: number) {}

  render() {
    return (
      <BCard bodyClass={style.body} class={style.card}>
        <Tabs
          currentTabIndex={this.currentTabIndex}
          onTabIndexChange={this.onTabIndexChange}
        >
          <Tabs.Tab title="Connections" id="connections">
            <ObjectTypeConnections
              value={this.value}
              allTypes={this.allTypes}
              allEnumTypes={this.allEnumTypes ?? undefined}
            />
          </Tabs.Tab>
          {this.apiClient && this.apiSchemaHandler && (
            <Tabs.Tab title="Triggers" id="triggers">
              <ObjectTypeTriggers
                value={this.value}
                allTypes={this.allTypes}
                allEnumTypes={this.allEnumTypes ?? undefined}
                apiClient={this.apiClient}
                apiSchemaHandler={this.apiSchemaHandler}
              />
            </Tabs.Tab>
          )}
        </Tabs>
      </BCard>
    );
  }
}
